// ** React Imports
import { lazy } from "react";
import { Redirect } from "react-router-dom";

const AppRoutes = [
  {
    path: "/apps/ticket-support",
    exact: true,
    appLayout: true,
    className: "email-application",
    component: lazy(() => import("../../views/apps/email")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/proposals/edit-proposal/:proposalId",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/proposals")),
    exact: true,
    meta: {
      navLink: "/apps/clients",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/proposals/:alias",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/proposals")),
    exact: true,
    meta: {
      navLink: "/apps/clients",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/clients/detail/:clientId",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/client")),
    exact: true,
    meta: {
      navLink: "/apps/clients",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/clients/edit/:clientId",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/client")),
    exact: true,
    meta: {
      navLink: "/apps/clients",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/clients",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/client")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/view-clients",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/client-view-board")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/all-contact/add-new",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/contact")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/all-contact",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/contact")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/client-project",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/client-project")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/client-report",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/client-report")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/follow-up/edit-followUp/:followId",
    className: "follow-up",
    component: lazy(() => import("../../views/apps/ecommerce/follow-up")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/follow-up",
    className: "follow-up",
    component: lazy(() => import("../../views/apps/ecommerce/follow-up")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/proposals",
    className: "proposals",
    component: lazy(() => import("../../views/apps/ecommerce/proposals")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/proposals/:alias",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/proposals")),
    exact: true,
    meta: {
      navLink: "/apps/clients",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/notice-board/:noticeId",
    className: "notice-board-application",
    component: lazy(() => import("../../views/apps/ecommerce/notice-board1")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/notice-board",
    className: "notice-board-application",
    component: lazy(() => import("../../views/apps/ecommerce/notice-board1")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/company-notice",
    className: "company-notice-application",
    component: lazy(() => import("../../views/apps/ecommerce/company-notice")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/custom-fields",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/custom-fields")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/setup-wizard",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/getting-started")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/setup-workchat/:id",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/setup-workchat")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/setup-workchat",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/setup-workchat")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/connect",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/connect/index")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/connect-whatsApp",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/connect/whatsApp")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/connect-messenger",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/connect/messenger")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/connect-wix",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/connect/wix")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/connect-shopify",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/connect/shopify")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/connect-wordpress",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/connect/wordpress")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/role-permissions",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/role-permissions")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/module-settings",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/module-settings")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/notification",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/notification")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/company-settings",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/company")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/taxes/edit/:taxId",
    className: "settings-application",
    component: lazy(() => import("../../views/apps/ecommerce/settings/tax")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/taxes",
    className: "settings-application",
    component: lazy(() => import("../../views/apps/ecommerce/settings/tax")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/project-settings",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/project-settings")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/leaves-settings/edit-type/:typeId",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/leaves-settings")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/leaves-settings",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/leaves-settings")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },

  {
    path: "/apps/tickets/all-tickets/:ticketId",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/tickets/add-tickets")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/tickets/add-tickets/edit/:ticketId",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/tickets/add-tickets")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/tickets/all-tickets",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/tickets/add-tickets")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/tickets",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/tickets")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/account-settings",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/account-settings")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/all-events",
    className: "settings-application",
    component: lazy(() => import("../../views/apps/ecommerce/new-events")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  // {
  //   path: "/apps/events",
  //   className: "settings-application",
  //   component: lazy(() => import("../../views/apps/ecommerce/events")),
  //   meta: {
  //     action: "read",
  //     resource: "ACL",
  //   },
  // },
  {
    path: "/apps/settings/setting-chat-widgets",
    className: "settings-application",
    component: lazy(() => import("../../views/apps/ecommerce/settings/chat")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/form-setting-chat",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/chat/setting-chat")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/whatsapp-connect",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/chat/whatsapp-connect")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/messenger-connect",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/chat/messenger-connect")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/form-chat-widget/:id",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/chat/form")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/form-chat-widget",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/chat/form")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/billing",
    className: "settings-billing",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/billing")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/company-portal",
    className: "settings-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/company-portal")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/whatsapp-cloud-api-setup",
    className: "settings-cloud-api-setup",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/chat/whatsapp-bussiness")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/ai-assistant-setup",
    className: "settings-ai-assistant-api-setup",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/chat/ai-assistant")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/email/:folder",
    exact: true,
    appLayout: true,
    className: "email-application",
    component: lazy(() => import("../../views/apps/email")),
    meta: {
      navLink: "/apps/email",
    },
  },
  {
    path: "/apps/ticket-support/status/:label",
    exact: true,
    appLayout: true,
    className: "email-application",
    component: lazy(() => import("../../views/apps/email")),
    meta: {
      navLink: "/apps/ticket-support",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/email/:filter",
    component: lazy(() => import("../../views/apps/email")),
    meta: {
      navLink: "/apps/email",
    },
  },
  {
    path: "/apps/chat-dashboard",
    exact: true,
    // appLayout: true, // css layout khác
    className: "todo-application",
    component: lazy(() => import("../../views/apps/work-chat/chat-dashboard")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/chat-broadcast",
    exact: true,
    className: "todo-application",
    component: lazy(() => import("../../views/apps/work-chat/chat-broadcast")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/clients/detail/:clientId",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/client")),
    exact: true,
    meta: {
      navLink: "/apps/clients",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/template-repository",
    exact: true,
    className: "todo-application",
    component: lazy(() => import("../../views/apps/work-chat/template-repository")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/chat-team",
    exact: true,
    className: "todo-application",
    component: lazy(() => import("../../views/apps/work-chat/chat-team")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/message/:channel/:userData",
    appLayout: true,
    className: "chat-application",
    component: lazy(() => import("../../views/apps/chat")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/message/:channel",
    appLayout: true,
    className: "chat-application", 
    component: lazy(() => import("../../views/apps/chat")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/message",
    appLayout: true,
    className: "chat-application",
    component: lazy(() => import("../../views/apps/chat")),
    meta: {
      action: "read", 
      resource: "ACL",
    },
  },
  {
    path: "/apps/chat-file-storage",
    exact: true,
    className: "todo-application",
    component: lazy(() => import("../../views/apps/work-chat/chat-file-storage")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/chat-segments/edit/:idSegment",
    exact: true,
    className: "todo-application",
    component: lazy(() => import("../../views/apps/work-chat/segments")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/chat-segments/create",
    exact: true,
    className: "todo-application",
    component: lazy(() => import("../../views/apps/work-chat/segments")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/chat-segments",
    exact: true,
    className: "todo-application",
    component: lazy(() => import("../../views/apps/work-chat/segments")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/todo",
    exact: true,
    appLayout: true,
    className: "todo-application",
    component: lazy(() => import("../../views/apps/todo")),
  },
  {
    path: "/apps/todo/:filter",
    appLayout: true,
    exact: true,
    className: "todo-application",
    component: lazy(() => import("../../views/apps/todo")),
    meta: {
      navLink: "/apps/todo",
    },
  },
  {
    path: "/apps/todo/tag/:tag",
    appLayout: true,
    className: "todo-application",
    component: lazy(() => import("../../views/apps/todo")),
    meta: {
      navLink: "/apps/todo",
    },
  },
  {
    path: "/apps/calendar",
    component: lazy(() => import("../../views/apps/calendar")),
  },
  {
    path: "/apps/invoice/list",
    component: lazy(() => import("../../views/apps/invoice/list")),
    meta: {
      navLink: "/apps/invoice/list",
    },
  },
  {
    path: "/apps/invoice/preview/:id",
    component: lazy(() => import("../../views/apps/invoice/preview")),
    meta: {
      navLink: "/apps/invoice/preview",
    },
  },
  {
    path: "/apps/invoice/preview",
    exact: true,
    component: () => <Redirect to="/apps/invoice/preview/4987" />,
  },
  {
    path: "/apps/invoice/edit/:id",
    component: lazy(() => import("../../views/apps/invoice/edit")),
    meta: {
      navLink: "/apps/invoice/edit",
    },
  },
  {
    path: "/apps/invoice/edit",
    exact: true,
    component: () => <Redirect to="/apps/invoice/edit/4987" />,
  },
  {
    path: "/apps/invoice/add",
    component: lazy(() => import("../../views/apps/invoice/add")),
  },
  {
    path: "/apps/invoice/print",
    layout: "BlankLayout",
    component: lazy(() => import("../../views/apps/invoice/print")),
  },
  {
    path: "/apps/ecommerce/shop",
    className: "ecommerce-application",
    component: lazy(() => import("../../views/apps/ecommerce/shop")),
  },
  {
    path: "/apps/ecommerce/wishlist",
    className: "ecommerce-application",
    component: lazy(() => import("../../views/apps/ecommerce/wishlist")),
  },
  {
    path: "/apps/ecommerce/product-detail",
    exact: true,
    className: "ecommerce-application",
    component: () => (
      <Redirect to="/apps/ecommerce/product-detail/apple-i-phone-11-64-gb-black-26" />
    ),
  },
  {
    path: "/apps/ecommerce/product-detail/:product",
    exact: true,
    className: "ecommerce-application",
    component: lazy(() => import("../../views/apps/ecommerce/detail")),
    meta: {
      navLink: "/apps/ecommerce/product-detail",
    },
  },
  {
    path: "/apps/create-profile",
    className: "ecommerce-application",
    component: lazy(() => import("../../views/apps/ecommerce/create-profile")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/checkout",
    className: "ecommerce-application",
    component: lazy(() => import("../../views/apps/ecommerce/checkout")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/proposal/view/:id",
    className: "ecommerce-application",
    component: lazy(() => import("../../views/apps/view-proposal")),
    meta: {
      action: "read",
      resource: "ACL",
      publicRoute: true,
      menuHidden: true,
    },
  },
  {
    path: "/invite",
    className: "ecommerce-application",
    component: lazy(() => import("../../views/apps/invite-employee")),
    meta: {
      action: "read",
      resource: "ACL",
      publicRoute: true,
      menuHidden: true,
    },
  },
  {
    path: "/estimate/view/:id",
    className: "ecommerce-application",
    component: lazy(() => import("../../views/apps/view-estimate")),
    meta: {
      action: "read",
      resource: "ACL",
      publicRoute: true,
      menuHidden: true,
    },
  },
  {
    path: "/apps/estimate/edit-estimate/:estimateId",
    className: "client-application",
    component: lazy(() => import("../../views/apps/ecommerce/finance/estimates")),
    exact: true,
    meta: {
      navLink: "/apps/clients",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/email/verify",
    className: "ecommerce-application",
    component: lazy(() => import("../../views/apps/verify-email")),
    meta: {
      action: "read",
      resource: "ACL",
      publicRoute: true,
      menuHidden: true,
    },
  },
  {
    path: "/email/app-token",
    className: "ecommerce-application",
    component: lazy(() => import("../../views/apps/misc/AppTokenEmail.js")),
    meta: {
      action: "read",
      resource: "ACL",
      publicRoute: true,
      menuHidden: true,
    },
  },
  {
    path: "/apps/kanban",
    className: "kanban-application",
    component: lazy(() => import("../../views/apps/kanban")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },

  {
    path: "/apps/settings/products/edit-product/:productId",
    className: "ecommerce-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/products")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/all-products",
    className: "ecommerce-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/products")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/settings/proposal",
    className: "ecommerce-application",
    component: lazy(() =>
      import("../../views/apps/ecommerce/settings/proposal")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/user/list",
    className: "ecommerce-application",
    component: lazy(() => import("../../views/apps/user/list")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/user/view",
    exact: true,
    component: () => <Redirect to="/apps/user/view/1" />,
  },
  {
    path: "/apps/user/view/:id",
    component: lazy(() => import("../../views/apps/user/view")),
    meta: {
      navLink: "/apps/user/view",
    },
  },
  {
    path: "/apps/roles",
    component: lazy(() => import("../../views/apps/roles-permissions/roles")),
  },
  {
    path: "/apps/permissions",
    component: lazy(() =>
      import("../../views/apps/roles-permissions/permissions")
    ),
  },
  {
    path: "/apps/whatsapp-business/broadcast",
    className: "settings-cloud-api-setup",
    component: lazy(() =>
      import("../../views/apps/business/dashboard")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/whatsapp-business/history",
    className: "settings-cloud-api-setup",
    component: lazy(() =>
      import("../../views/apps/business/history")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/whatsapp-business/segmentation/:segmentId",
    component: lazy(() => 
      import("../../views/apps/business/segmentation")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/whatsapp-business/segmentation",
    className: "settings-cloud-api-setup",
    component: lazy(() =>
      import("../../views/apps/business/segmentation")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/whatsapp-business/setup-api",
    className: "settings-cloud-api-setup",
    component: lazy(() =>
      import("../../views/apps/business/setup-api")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/whatsapp-business/template-repository",
    className: "settings-cloud-api-setup",
    component: lazy(() =>
      import("../../views/apps/business/template-repository")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/whatsapp-business/template-message",
    className: "settings-cloud-api-setup",
    component: lazy(() =>
      import("../../views/apps/business/template-message")
    ),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
];

export default AppRoutes;
